module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "layui-nav layui-nav-tree layui-tab m0",
    attrs: {
      "i": "layui-nav",
      "lay-filter": "demo"
    }
  }, _vm._l((_vm.navData), function(nav) {
    return _c('li', {
      staticClass: "layui-nav-item"
    }, [_c('a', {
      staticClass: "javascript:;",
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_vm._v(_vm._s(nav.parent)), _c('span', {
      staticClass: "layui-nav-more"
    })]), _vm._v(" "), _vm._l((nav.sub), function(sub) {
      return _c('dl', {
        staticClass: "layui-nav-child"
      }, [_c('dd', [(sub.icon) ? _c('router-link', {
        attrs: {
          "to": sub.link
        }
      }, [_c('i', {
        staticClass: "fa",
        class: sub.icon
      }), _c('cite', [_vm._v(_vm._s(sub.title))])]) : _c('router-link', {
        attrs: {
          "to": sub.link
        }
      }, [_vm._v(_vm._s(sub.title))])], 1)])
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2932188a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 900
// module chunks = 42